import mainHeaderTemplate from '../partials/mainHeader.html';

MainHeader.$inject = ['$rootScope', '$state'];

export function MainHeader($rootScope, $state) {
    return {
        transclude: true,
        scope: {
            id: '@tnId',
            section: '@section',
            title: '@title',
            titleRoute: '@?titleRoute',
            titleParams: '=?titleParams',
            subtitle: '@subtitle',
        },
        template: mainHeaderTemplate,
        link: function (scope) {
            scope.titleRoute = scope.titleRoute || 'home.foundry.fonts.styles';
            scope.titleParams = scope.titleParams || {};
            // scope.titleUrl = $state.href(scope.titleRoute, scope.titleParams);

            scope.followTitleLink = () => {
                $state.go(scope.titleRoute, scope.titleParams);
            };

            function updateBreadcrumbs() {
                if (!$rootScope.$breadcrumbs) return;
                const l = $rootScope.$breadcrumbs.length;
                if (l > 1) {
                    scope.previousTitle = $rootScope.$breadcrumbs[l - 2].title;
                    if (scope.previousTitle) {
                        scope.previousTitle = scope.previousTitle
                            .split('·')[0]
                            .trim();
                    }
                }
            }
            scope.$watch($rootScope.$breadcrumbs, updateBreadcrumbs);
            updateBreadcrumbs();

            if ($state.current.name !== 'home.foundry.fonts.listing') {
                scope.headerFoundryShadow = $rootScope.headerFoundry;
            }

            prepSectionState();

            function prepSectionState() {
                if (scope.section) {
                    const sectionState = $state.get(scope.section);
                    if (sectionState) {
                        scope.sectionState = sectionState;
                        scope.sectionState.url = $state.href(sectionState);
                        if (
                            sectionState.selfData &&
                            sectionState.selfData.breadcrumbTitle
                        ) {
                            scope.previousTitle =
                                sectionState.selfData.breadcrumbTitle;
                        }
                    } else {
                        scope.sectionState = {
                            name: scope.section.toLowerCase(),
                            title: scope.section,
                            url: scope.section.toLowerCase(),
                        };
                    }
                }
            }
        },
    };
}
